<template>

    <li class="athlete__block">
        <a href="#" target="_self">

            <div class="vh">
                Loading Block
            </div>

            <div class="athlete__medals athlete__block__empty__medals"></div>

            <div class="athlete__block__empty__figure"></div>

            <div class="athlete__block__empty__title"></div>

            <div class="athlete__block__empty__sports"></div>

        </a>
    </li>

</template>
